import AdjustLeaveModal from "@/models/AdjustLeave";

const GET_SYS_QY_DEP = 'GET_SYS_QY_DEP';
const ADD_VACATION_LOG_LIST = 'ADD_VACATION_LOG_LIST';
const VACATION_LOG_LIST = 'VACATION_LOG_LIST';
const UPDATE_ONE_USER_QUOTA = 'UPDATE_ONE_USER_QUOTA';
const GET_SYS_HOLIDAY = 'GET_SYS_HOLIDAY';

// 获取部门
async function getSysQYDep(params) {
  const payload = await new AdjustLeaveModal().getSysQYDep(params);
  return {
    type: GET_SYS_QY_DEP,
    payload
  };
}

// 获取剩余明细
async function addVacationLogList(params) {
  const payload = await new AdjustLeaveModal().addVacationLogList(params);
  return {
    type: ADD_VACATION_LOG_LIST,
    payload
  };
}

// 获取明细列表
async function vacationLogList(params) {
  const payload = await new AdjustLeaveModal().vacationLogList(params);
  return {
    type: VACATION_LOG_LIST,
    payload
  };
}

// 修改成员假期余额
async function updateOneUserQuota(params) {
  const payload = await new AdjustLeaveModal().updateOneUserQuota(params);
  return {
    type: UPDATE_ONE_USER_QUOTA,
    payload
  };
}

async function getSysHoliday(params) {
  const payload = await new AdjustLeaveModal().getSysHoliday(params);
  return {
    type: GET_SYS_HOLIDAY,
    payload
  };
}

const ACTION_TYPES = {
  GET_SYS_QY_DEP,
  ADD_VACATION_LOG_LIST,
  VACATION_LOG_LIST,
  UPDATE_ONE_USER_QUOTA,
  GET_SYS_HOLIDAY
};

const ACTION = {
  getSysQYDep,
  addVacationLogList,
  vacationLogList,
  updateOneUserQuota,
  getSysHoliday
};

const VacationEdit = {
  ACTION_TYPES,
  ACTION
}

export default VacationEdit;